var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUk({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_1172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.5H27V20.5H0V0.5Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16406 0.5L13.4578 8.04167L23.7094 0.5H27V3.08333L16.875 10.5417L27 17.9583V20.5H23.625L13.5 13.0417L3.41719 20.5H0V18L10.0828 10.5833L0 3.16667V0.5H3.16406Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8875 12.2083L27 18.8333V20.5L15.5672 12.2083H17.8875ZM10.125 13.0417L10.3781 14.5L2.27813 20.5H0L10.125 13.0417ZM27 0.5V0.625L16.4953 8.45833L16.5797 6.625L24.8906 0.5H27ZM0 0.5L10.0828 7.83333H7.55156L0 2.25V0.5Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1672 0.5V20.5H16.9172V0.5H10.1672ZM0 7.16667V13.8333H27V7.16667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.54167V12.5417H27V8.54167H0ZM11.5172 0.5V20.5H15.5672V0.5H11.5172Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_1172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/uk.9ef4aebb.svg";
export { ForwardRef as ReactComponent };